export const heroes = [
    {
        'id': 'dc-batman',
        'superhero':'Batman', 
        'publisher':'DC Comics', 
        'alter_ego':'Bruce Wayne',
        'first_appearance':'Detective Comics #27',
        'characters':'Bruce Wayne',
        'url_main':'dc'
    },
    {
        'id': 'dc-superman',
        'superhero':'Superman', 
        'publisher':'DC Comics', 
        'alter_ego':'Kal-El',
        'first_appearance':'Action Comics #1',
        'characters':'Kal-El',
        'url_main':'dc'
    },
    {
        'id': 'dc-flash',
        'superhero':'Flash', 
        'publisher':'DC Comics', 
        'alter_ego':'Jay Garrick',
        'first_appearance':'Flash Comics #1',
        'characters':'Jay Garrick, Barry Allen, Wally West, Bart Allen',
        'url_main':'dc'
    },
    {
        'id': 'dc-green',
        'superhero':'Green Lantern', 
        'publisher':'DC Comics', 
        'alter_ego':'Alan Scott',
        'first_appearance':'All-American Comics #16',
        'characters':'Alan Scott, Hal Jordan, Guy Gardner, John Stewart, Kyle Raynor, Jade, Sinestro, Simon Baz',
        'url_main':'dc'
    },
    {
        'id': 'dc-arrow',
        'superhero':'Green Arrow', 
        'publisher':'DC Comics', 
        'alter_ego':'Oliver Queen',
        'first_appearance':'More Fun Comics #73',
        'characters':'Oliver Queen',
        'url_main':'dc'
    },
    {
        'id': 'dc-wonder',
        'superhero':'Wonder Woman', 
        'publisher':'DC Comics', 
        'alter_ego':'Princess Diana',
        'first_appearance':'All Star Comics #8',
        'characters':'Princess Diana',
        'url_main':'dc'
    },
    {
        'id': 'dc-martian',
        'superhero':'Martian Manhunter', 
        'publisher':'DC Comics', 
        'alter_ego':'J\'onn J\'onzz',
        'first_appearance':'Detective Comics #225',
        'characters':'Martian Manhunter',
        'url_main':'dc'
    },
    {
        'id': 'dc-robin',
        'superhero':'Robin/Nightwing', 
        'publisher':'DC Comics', 
        'alter_ego':'Dick Grayson',
        'first_appearance':'Detective Comics #38',
        'characters':'Dick Grayson',
        'url_main':'dc'
    },
    {
        'id': 'dc-blue',
        'superhero':'Blue Beetle', 
        'publisher':'DC Comics', 
        'alter_ego':'Dan Garret',
        'first_appearance':'Mystery Men Comics #1',
        'characters':'Dan Garret, Ted Kord, Jaime Reyes',
        'url_main':'dc'
    },
    {
        'id': 'dc-black',
        'superhero':'Black Canary', 
        'publisher':'DC Comics', 
        'alter_ego':'Dinah Drake',
        'first_appearance':'Flash Comics #86',
        'characters':'Dinah Drake, Dinah Lance',
        'url_main':'dc'
    },
    {
        'id': 'marvel-spider',
        'superhero':'Spider Man', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Peter Parker',
        'first_appearance':'Amazing Fantasy #15',
        'characters':'Peter Parker',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-captain',
        'superhero':'Captain America', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Steve Rogers',
        'first_appearance':'Captain America Comics #1',
        'characters':'Steve Rogers',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-iron',
        'superhero':'Iron Man', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Tony Stark',
        'first_appearance':'Tales of Suspense #39',
        'characters':'Tony Stark',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-thor',
        'superhero':'Thor', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Thor Odinson',
        'first_appearance':'Journey into Myster #83',
        'characters':'Thor Odinson',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-hulk',
        'superhero':'Hulk', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Bruce Banner',
        'first_appearance':'The Incredible Hulk #1',
        'characters':'Bruce Banner',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-wolverine',
        'superhero':'Wolverine', 
        'publisher':'Marvel Comics', 
        'alter_ego':'James Howlett',
        'first_appearance':'The Incredible Hulk #180',
        'characters':'James Howlett',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-daredevil',
        'superhero':'Daredevil', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Matthew Michael Murdock',
        'first_appearance':'Daredevil #1',
        'characters':'Matthew Michael Murdock',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-hawkeye',
        'superhero':'Hawkeye', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Clinton Francis Barton',
        'first_appearance':'Tales of Suspense #57',
        'characters':'Clinton Francis Barton',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-cyclops',
        'superhero':'Cyclops', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Scott Summers',
        'first_appearance':'X-Men #1',
        'characters':'Scott Summers',
        'url_main':'marvel'
    },
    {
        'id': 'marvel-silver',
        'superhero':'Silver Surfer', 
        'publisher':'Marvel Comics', 
        'alter_ego':'Norrin Radd',
        'first_appearance':'The Fantastic Four #48',
        'characters':'Norrin Radd',
        'url_main':'marvel'
    },
    {
        'id': 'bha-allmight',
        'superhero':'All Might', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Toshinori Yagi',
        'first_appearance':'MHGA/Episodio: 02',
        'characters':'Toshinori Yagi',
        'url_main':'bha'
    },
    {
        'id': 'bha-dynamight',
        'superhero':'Dynamight', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Katsuki Bakugo',
        'first_appearance':'MHGA/Episodio: 01',
        'characters':'Katsuki Bakugo',
        'url_main':'bha'
    },
    {
        'id': 'bha-deku',
        'superhero':'Deku', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Izuku Midoriya',
        'first_appearance':'MHGA/Episodio: 01',
        'characters':'Izuku Midoriya',
        'url_main':'bha'
    },
    {
        'id': 'bha-froppy',
        'superhero':'Froppy', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Tsuyu Asui',
        'first_appearance':'MHGA/Episodio: 05',
        'characters':'Tsuyu Asui',
        'url_main':'bha'
    },
    {
        'id': 'bha-grantorino',
        'superhero':'Gran Torino', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Sorahiko Torino',
        'first_appearance':'MHGA/Episodio: 46',
        'characters':'Sorahiko Torino',
        'url_main':'bha'
    },
    {
        'id': 'bha-redriot',
        'superhero':'Red Riot', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Eijiro Kirishima',
        'first_appearance':'MHGA/Episodio: 03',
        'characters':'Eijiro Kirishima',
        'url_main':'bha'
    },
    {
        'id': 'bha-lemillion',
        'superhero':'Lemillion', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Mirio Togata',
        'first_appearance':'MHGA/Episodio: 121',
        'characters':'Mirio Togata',
        'url_main':'bha'
    },
    {
        'id': 'bha-ingenium',
        'superhero':'Ingenium', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Tenya Iida',
        'first_appearance':'MHGA/Episodio: 03',
        'characters':'Tenya Iida',
        'url_main':'bha'
    },
    {
        'id': 'bha-shoto',
        'superhero':'Shoto', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Shoto Todoroki',
        'first_appearance':'MHGA/Episodio: 06',
        'characters':'Shoto Todoroki',
        'url_main':'bha'
    },
    {
        'id': 'bha-uravity',
        'superhero':'Uravity', 
        'publisher':'Shōnen Jump', 
        'alter_ego':'Ochaco Uraraka',
        'first_appearance':'MHGA/Episodio: 03',
        'characters':'Ochaco Uraraka',
        'url_main':'bha'
    }
]